let navBuyBtns = document.querySelectorAll(".nav_buy_item");
if (navBuyBtns.length > 0) {
  for (let btn of navBuyBtns) {
    btn.addEventListener("click", function () {
      removeClassInElements(".nav_buy_item", "active_border_bottom");
      this.classList.add("active_border_bottom");
      let dataUrl = this.getAttribute("data-url");
      let dataUserType = this.getAttribute("data-user-type");
      let dataProductID = this.getAttribute("data-product-id");

      lockScroll();
      getBuyContent(dataUrl, dataUserType, dataProductID);

      // Update the URL with the new parameters
      let newUrl = updateURLWithParameters(dataUrl, dataUserType, dataProductID);
      history.pushState({path: newUrl}, '', newUrl);
    });
  }
}

function getBuyContent(urlRequest, userType, productID) {
  console.log('getBuyContent');
  //console.log('urlRequest='+urlRequest);
  //alert(urlRequest);
  resetSaleTimers();
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params =
    "userType=" + userType + "&productID=" + productID + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (response.status === "ok") {
          //console.log(response);
          //alert(JSON.stringify(response));
          document.querySelector("#block_buy_content").innerHTML = response.html;

          pushGAEcommerceDataLayer(response.eventGA4DataJson, response.eventUADataJson);

          //facebookPixelEvent('ViewContent', response.productTitle, response.price, response.userTypeName, response.licenseTypeName, false);
          document
            .querySelector("#block_buy_content")
            .classList.add("active_buy_content");
          callAllFuncForContent();
          select();
          unlockScroll();
          setTimerToBlock();
        }
        if (response.status === "error") {
          console.log(response.errors);
          unlockScroll();
        }
        if (response.status === "error404") {
          window.location.href = response.url;
          unlockScroll();
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function setListenerForTerm() {
  let btnsTerm = document.querySelectorAll(".btn_term");
  if (btnsTerm.length > 0) {
    for (let btn of btnsTerm) {
      btn.addEventListener("click", function () {
        let dataUrl = this.getAttribute("data-url");
        let dataUserType = this.getAttribute("data-user-type");
        let dataProductID = this.getAttribute("data-product-id");
        let dataTypeLicense = this.getAttribute("data-type-license");
        
        removeClassInElements(".btn_term", "active");
        this.classList.add("active");
        if (!this.getAttribute("data-term-form")) {
          lockScroll();
          getBuyTermContent(
            dataUrl,
            dataUserType,
            dataProductID,
            dataTypeLicense
          );
        }

        // Update the URL with the new parameters
        let newUrl = updateURLWithParameters(dataUrl, dataUserType, dataProductID, dataTypeLicense);
        history.pushState({path: newUrl}, '', newUrl)

      });
    }
  }
}

function updateURLWithParameters(dataUrl, userType, productId, typeLicense='') {
  const params = new URLSearchParams(window.location.search);

  if (userType) {
    // Set 'user-type' parameter if userType is truthy
    params.set('user-type', user_types_all[userType]);
  } else {
    // Remove 'user-type' parameter if userType is falsy
    if (params.has('user-type')) {
      params.delete('user-type');
    }
  }
  if(productId) params.set('product-id', productId);

  if (typeLicense) {
    params.set('type-license', license_types_all[typeLicense]);
  } else {
    // Remove 'user-type' parameter if userType is falsy
    if (params.has('type-license')) {
      params.delete('type-license');
    }
  }

  return window.location.pathname + '?' + params.toString();
}

function findNavBuyItemByUserType(userType) {
  // Build the selector to find the .nav_buy_item with the specified data-user-type
  const selector = `.nav_buy_item[data-user-type="${userType}"]`;

  // Use querySelector to find the first element that matches the selector
  const element = document.querySelector(selector);

  // Check if an element was found and return it; otherwise, return null or a message
  if (element) {
    return element;
  } else {
    console.log("No element found with data-user-type:", userType);
    return null;
  }
}

function getKeyByValue(object, value) {
  for (let key in object) {
    if (object[key] === value) {
      return key;
    }
  }
  return null; // Return null if no key found
}

function loadContentFromURLParams() {
  // Parse the URL parameters
  const params = new URLSearchParams(window.location.search);
  let dataUrl = params.get('data-url');
  let userTypeAlias = params.get('user-type');
  let productId = params.get('product-id');
  let typeLicenseAlias = params.get('type-license');

  if(!dataUrl){
    dataUrl = '/products/store/ajax';
  }

  // Check if all necessary parameters are present
  if (userTypeAlias) {
    const userType = getKeyByValue(user_types_all, userTypeAlias);
    removeClassInElements(".nav_buy_item", "active_border_bottom");
    let nav_buy_item_element = findNavBuyItemByUserType(userType);
    nav_buy_item_element.classList.add("active_border_bottom");
    // Call the content loading function with the parsed parameters

    if (typeLicenseAlias) {
      const typeLicense = getKeyByValue(license_types_all, typeLicenseAlias);
      getBuyTermContent(dataUrl, userType, productId, typeLicense);
    }else{
      lockScroll();
      getBuyContent(dataUrl, userType, productId);
    }
  }
}

document.addEventListener('DOMContentLoaded', loadContentFromURLParams);

function getBuyTermContent(urlRequest, userType, productID, typeLicense) {
  console.log('getBuyTermContent');
  resetSaleTimers();
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params =
    "userType=" +
    userType +
    "&productID=" +
    productID +
    "&licenseTypeID=" +
    typeLicense +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    console.log("request.readyState", request.readyState);
    if (request.readyState === 4) {
      if(request.status === 200) {
        //console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (response.status === "ok") {
          document.querySelector("#block_buy_content").innerHTML = response.html;


          //facebookPixelEvent('ViewContent', response.productTitle, response.price, response.userTypeName, response.licenseTypeName, false);
          pushGAEcommerceDataLayer(response.eventGA4DataJson, response.eventUADataJson);


          callAllFuncForContent();
          select();
          unlockScroll();
          setTimerToBlock();
        }
        if (response.status === "error") {
          console.log(response.errors);
          unlockScroll();
        }
        if (response.status === "error404") {
          window.location.href = response.url;
          unlockScroll();
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function selectBuyTerms() {
  let selectHeader = document.querySelectorAll(".select__header_term");
  let selectItem = document.querySelectorAll(".select__item_term");

  selectHeader.forEach((item) => {
    item.addEventListener("click", function () {
      closeAllSelect(this.parentElement);
      this.parentElement.classList.toggle("active");
    });
  });

  selectItem.forEach((item) => {
    item.addEventListener("click", function () {
      let dataUrl = this.getAttribute("data-url");
      let dataUserType = this.getAttribute("data-user-type");
      let dataProductID = this.getAttribute("data-product-id");
      let dataTypeLicense = this.getAttribute("data-type-license");
      let text = this.innerText,
        select = this.closest(".select"),
        currentText = select.querySelector(".select__current");
      currentText.innerText = text;
      currentText.setAttribute("data-url", dataUrl);
      currentText.setAttribute("data-user-type", dataUserType);
      currentText.setAttribute("data-product-id", dataProductID);
      currentText.setAttribute("data-type-license", dataTypeLicense);
      select.classList.remove("active");
      if (!this.getAttribute("data-term-form")) {
        getBuyTermContent(
          dataUrl,
          dataUserType,
          dataProductID,
          dataTypeLicense
        );
      }
    });
  });
}

function callAllFuncForContent() {
  selectBuyTerms();
  setListenerForTerm();
  setDiscountBtnListener();
  setSiemaSlider();
  showBlockContent(
    ".btn_buy_free",
    document.querySelector("#block_student_buy_free"),
    "show_student_block"
  );
  showBlockContent(
    ".show_input",
    document.querySelector("#block_student_buy_for"),
    "show_student_block"
  );
  attachBtnLisener(
    document.getElementById("file"),
    document.getElementById("attach_file_name")
  );
  clickSendBtn();
}
callAllFuncForContent();

function attachBtnLisener(btnAttach, elForNameFile) {
  if (btnAttach !== null) {
    btnAttach &&
      btnAttach.addEventListener("change", function () {
        if (this.files.item(0) !== null) {
          elForNameFile.innerText = this.files.item(0).name;
        }
      });
  }
}

// SIEMA SLIDER
function setSiemaSlider() {
  const prev = document.querySelector(".nav_slider_prev");
  const next = document.querySelector(".nav_slider_next");
  var mySiema;

  prev && prev.addEventListener("click", () => mySiema.prev());
  next && next.addEventListener("click", () => mySiema.next());

  let siemaCards = document.querySelector("#siema_cards");

  if (window.matchMedia("(max-width: 900px)").matches) {
    siemaCards && siemaCards.classList.remove("block_compatible_cards");
    siemaCards && siemaCards.classList.add("siema");

    if (document.querySelector(".siema") !== null) {
      mySiema = new Siema({
        loop: true,
      });
    }
  } else {
    siemaCards && siemaCards.classList.add("block_compatible_cards");
    siemaCards && siemaCards.classList.remove("siema");
  }
}
// END SIEMA SLIDER
// VOLUME DISCOUNT MODAL
let modalVolumeDiscount = document.querySelector(".container_modal_discount");
let closeVolumeDiscount = document.querySelector(".close_modal_discount");
let btnModalBack = document.querySelector(".modal_btn_back");
let titleModalDiscoutn = document.querySelector(".modal_discount_title");

closeVolumeDiscount &&
  closeVolumeDiscount.addEventListener("click", function () {
    closeModalDiscount();
  });

btnModalBack &&
  btnModalBack.addEventListener("click", function () {
    closeModalDiscount();
  });
window.addEventListener("click", function (event) {
  if (event.target == modalVolumeDiscount) {
    closeModalDiscount();
  }
});
function closeModalDiscount() {
  modalVolumeDiscount.style.display = "none";
  unlockScroll();
}
closeModalESC(modalVolumeDiscount);
function openModalDiscount() {
  modalVolumeDiscount.style.display = "block";
  lockScroll();
}

function setDiscountBtnListener() {
  let btnsVolumeDiscount = document.querySelectorAll(".volume_discount");
  if (btnsVolumeDiscount.length > 0) {
    for (let btn of btnsVolumeDiscount) {
      btn.addEventListener("click", function () {

        titleModalDiscoutn.innerText =
          document.querySelector(".discount_title_hidden").innerText +
          this.closest(".content_card").querySelector(".title").innerText;
        let dataUrl = this.getAttribute("data-url");
        let dataId = this.getAttribute("data-id");
        let dataPriceType = this.getAttribute("data-price-type");
        getVolumeDiscount(dataUrl, dataId, dataPriceType);
      });
    }
  }
}
function getVolumeDiscount(urlRequest, ID, priceType) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  let params = "id=" + ID + "&price-type=" + priceType + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          document.querySelector("#block_discount_response").innerHTML =
            response.html;
          openModalDiscount();
        }
        if (response.status === "error") {
          console.log(response.errors);
        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END VOLUME DISCOUNT MODAL
// VALIDATION INPUTS FOR STUDENT
function clickSendBtn() {
  document.getElementById("btn_send_student") &&
    document
      .getElementById("btn_send_student")
      .addEventListener("click", function () {
        let inputName = document.getElementById("student_teacher_first_name");
        let inputLastName = document.getElementById(
          "student_teacher_last_name"
        );
        let inputEmail = document.getElementById("student_teacher_email");
        let inputCountry = document.getElementById(
          "select_student_teacher_country"
        );
        let inputSchoolUnivers = document.getElementById(
          "student_teacher_school_university"
        );
        let inputCityTown = document.getElementById(
          "student_teacher_city_town"
        );
        let inputCountKeys = document.getElementById("student_teacher_count_keys");
        let imgScan = document.querySelector("#file").files.item(0);

        let inputNameMsg = document.getElementById(
          "student_teacher_first_name_msg"
        );
        let inputLastNameMsg = document.getElementById(
          "student_teacher_last_name_msg"
        );
        let inputEmailMsg = document.getElementById(
          "student_teacher_email_msg"
        );
        let inputCountryMsg = document.getElementById(
          "student_teacher_country_msg"
        );
        let inputSchoolUniversMsg = document.getElementById(
          "student_teacher_school_university_msg"
        );
        let inputCityTownMsg = document.getElementById(
          "student_teacher_city_town_msg"
        );
        let inputCountKeysMsg = document.getElementById("student_teacher_count_keys_msg");
        let imgScanMsg = document.getElementById("id_scan_msg");

        if (!validateOnEmpty(inputName)) {
          inputNameMsg.classList.add("show_msg");
        } else {
          inputNameMsg.classList.remove("show_msg");
        }
        if (!validateOnEmpty(inputLastName)) {
          inputLastNameMsg.classList.add("show_msg");
        } else {
          inputLastNameMsg.classList.remove("show_msg");
        }
        if (!validateEmail(inputEmail)) {
          inputEmailMsg.classList.add("show_msg");
        } else {
          inputEmailMsg.classList.remove("show_msg");
        }
        if (!validateOnText(inputCountry)) {
          inputCountryMsg.classList.add("show_msg");
        } else {
          inputCountryMsg.classList.remove("show_msg");
        }
        if (!validateOnEmpty(inputSchoolUnivers)) {
          inputSchoolUniversMsg.classList.add("show_msg");
        } else {
          inputSchoolUniversMsg.classList.remove("show_msg");
        }
        if (!validateOnEmpty(inputCityTown)) {
          inputCityTownMsg.classList.add("show_msg");
        } else {
          inputCityTownMsg.classList.remove("show_msg");
        }
        if (!validateOnNumber(inputCountKeys)) {
          inputCountKeysMsg.classList.add("show_msg");
        } else {
          inputCountKeysMsg.classList.remove("show_msg");
        }
        if (!validateOnNull(imgScan)) {
          imgScanMsg.classList.add("show_msg");
          return;
        } else {
          imgScanMsg.classList.remove("show_msg");
        }
        let typeLicense = document
          .querySelector(".btn_term.active")
          .getAttribute("data-type-license");
        let typeUser = document
          .querySelector(".btn_term.active")
          .getAttribute("data-user-type");

        document.querySelector("#btn_send_student").classList.add("disabled");
        sendDataStudent(
          inputName.value,
          inputLastName.value,
          inputEmail.value,
          inputCountry.getAttribute("data-id"),
          inputSchoolUnivers.value,
          inputCityTown.value,
          inputCountKeys.value,
          imgScan,
          this.getAttribute("data-url"),
          typeLicense,
          typeUser,
          this.getAttribute("data-product-id")
        );
      });
}
function cleanInputStudent() {
  // clean input
  let inputName = document.getElementById("student_teacher_first_name");
  let inputLastName = document.getElementById("student_teacher_last_name");
  let inputEmail = document.getElementById("student_teacher_email");
  let inputCountry = document.getElementById("select_student_teacher_country");
  let inputSchoolUnivers = document.getElementById(
    "student_teacher_school_university"
  );
  let inputCityTown = document.getElementById("student_teacher_city_town");
  let inputCountKeys = document.getElementById("student_teacher_count_keys");
  let imgScan = document.querySelector("#file");
  let imgFileName = document.getElementById("attach_file_name");
  inputName.value = inputLastName.value = inputEmail.value = inputSchoolUnivers.value = inputCityTown.value = imgScan.value = inputCountKeys.value = "";
  inputCountry.innerHTML = "";
  imgFileName.innerHTML = "";
  inputCountry.removeAttribute("data-id");

  // clean input error msg
  let inputNameMsg = document.getElementById(
    "student_teacher_first_name_msg"
  );
  let inputLastNameMsg = document.getElementById(
    "student_teacher_last_name_msg"
  );
  let inputEmailMsg = document.getElementById(
    "student_teacher_email_msg"
  );
  let inputCountryMsg = document.getElementById(
    "student_teacher_country_msg"
  );
  let inputSchoolUniversMsg = document.getElementById(
    "student_teacher_school_university_msg"
  );
  let inputCityTownMsg = document.getElementById(
    "student_teacher_city_town_msg"
  );
  let inputCountKeysMsg = document.getElementById("student_teacher_count_keys_msg");
  let imgScanMsg = document.getElementById("id_scan_msg");

  inputNameMsg.classList.remove("show_msg");
  inputLastNameMsg.classList.remove("show_msg");
  inputEmailMsg.classList.remove("show_msg");
  inputCountryMsg.classList.remove("show_msg");
  inputSchoolUniversMsg.classList.remove("show_msg");
  inputCityTownMsg.classList.remove("show_msg");
  inputCountKeysMsg.classList.remove("show_msg");
  imgScanMsg.classList.remove("show_msg");

  document.querySelector("#btn_send_student").classList.remove("disabled");
}

function sendDataStudent(
  name,
  surname,
  email,
  country,
  schoolUnivers,
  cityTown,
  countKeys,
  img,
  urlRequest,
  licenseTypeID,
  userType,
  productID
) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  let formData = new FormData();
  formData.append("AcademicLicenseRequestForm[file]", img);
  formData.append("AcademicLicenseRequestForm[first_name]", name);
  formData.append("AcademicLicenseRequestForm[last_name]", surname);
  formData.append("AcademicLicenseRequestForm[email]", email);
  formData.append("AcademicLicenseRequestForm[school]", schoolUnivers);
  formData.append("AcademicLicenseRequestForm[country_id]", country);
  formData.append("AcademicLicenseRequestForm[city]", cityTown);
  formData.append("AcademicLicenseRequestForm[license_quantity]", countKeys);
  formData.append("AcademicLicenseRequestForm[user_type]", userType);
  formData.append("AcademicLicenseRequestForm[product_id]", productID);
  formData.append("AcademicLicenseRequestForm[license_type_id]", licenseTypeID);
  formData.append("_csrf", jst_csrf);
  request.open("POST", url, true);
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        let blockMsg = document.querySelector("#response_student_msg");
        if (response.status === "ok") {
          blockMsg.innerText = response.message;
          blockMsg.style.display = "block";
          cleanInputStudent();
          document.querySelector(".block_student_text").style.display = "none";
          document.querySelector(".block_form_inputs").style.display = "none";
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          blockMsg.innerText = responseErrorsMsg;
          blockMsg.style.display = "block";
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(formData);
}
let msgTextError = "error! try again!";

body && body.addEventListener("keypress", (e) => {
    let elEvent = event.target;
    let inputEl = elEvent.closest("#student_teacher_count_keys");
    if (inputEl) {
      if (e.which < 48 || e.which > 57)
      {
          e.preventDefault();
      }
    }
  });
// END VALIDATION INPUTS FOR STUDENT

// SHOW BLOCK FREE AND 50$ FOR STUDENT
function showBlockContent(elBtn, elBlock, classAdd) {
  let btnsShowInputs = document.querySelectorAll(elBtn);
  if (btnsShowInputs.length > 0) {
    for (let btn of btnsShowInputs) {
      btn.addEventListener("click", function () {
        if (!btn.classList.contains("popup-link")) {
          hideAllBlocksContent(classAdd);
          elBlock.classList.add(classAdd);
          removeClassInElements(".active_card_btn_buy", "active_card_btn_buy");
          this.classList.add("active_card_btn_buy");
          elBlock.scrollIntoView({block: "center", behavior: "smooth"});
          if (this.classList.contains("show_input")) {
            document.querySelector("#response_student_msg").innerText = "";
            document.querySelector("#response_student_msg").style.display = "none";
            document.querySelector(".block_student_text").style.display = "block";
            document.querySelector(".block_form_inputs").style.display = "block";
            cleanInputStudent();
            document
              .querySelector("#btn_send_student")
              .setAttribute(
                "data-product-id",
                this.getAttribute("data-product-id")
              );
          }
        }
      });
    }
  }
}
function hideAllBlocksContent(classEl) {
  let allBlocks = document.querySelectorAll("." + classEl);
  if (allBlocks.length > 0) {
    for (let block of allBlocks) {
      block.classList.remove(classEl);
    }
  }
}

// END SHOW BLOCK FREE AND 50$ FOR STUDENT

// RENT TO OWN (BTN MORE INFO)
const pathArray = window.location.pathname;
if(pathArray.includes("licensing")) {
  const rentToOwnId = document.querySelector("#rent-to-own");
  if(rentToOwnId !== null) {
    rentToOwnId.scrollIntoView({block: "center", behavior: "smooth"})
  }
}
// END RENT TO OWN


// SALE TIMER 
// Update the count down every 1 second
function startTimerSale(timerEl) {
  let translate_for_discount = document.querySelector("#translate_for_discount").innerText;

  let now = new Date().getTime();
  let utcSeconds = timerEl.getAttribute("data-time-end");
  let countDownDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
  countDownDate.setUTCSeconds(utcSeconds);
  // Find the distance between now and the count down date
  let distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes and seconds
  let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((distance % (1000 * 60)) / 1000);

  let textForDay;

  if(days <= 0) {
    textForDay = "";
  } else {
    textForDay = `${days} ${translate_for_discount}`
  }

  if(days < 0) {
    timerEl.innerHTML = " <span>00</span>:<span>00</span>:<span>00</span>";
  } else {
    timerEl.innerHTML = textForDay + " <span>" + ("0" + hours).slice(-2) + "</span>:<span>"
  + ("0" + minutes).slice(-2) + "</span>:<span>" + ("0" + seconds).slice(-2) + "</span>";
  }
    
};

let allSaleTimers;

// set setInterval for all block with discount timers
function setTimerToBlock() {
  allSaleTimers = [];
  let allTimersOnPage = document.querySelectorAll(".block_sale_timer .sale_timer");
  if(allTimersOnPage.length != 0) {
    for (let timer of allTimersOnPage) {   
      allSaleTimers.push(setInterval( function() {  startTimerSale(timer); }, 1000 ));
    }
  }
}
setTimerToBlock();

// clean discount timers
function resetSaleTimers() {
  for (let saleTimer of allSaleTimers) {
    clearInterval(saleTimer);
  }
  allSaleTimers = [];
}
// END SALE TIMER